import { render } from "./ImageFileFailIcon.vue?vue&type=template&id=d621d220"
import script from "./ImageFileFailIcon.vue?vue&type=script&lang=js"
export * from "./ImageFileFailIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__